import Api from './dist/services/api.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { StandardForm } from './dist/components/wm-standard-form';
import { StandardView } from './dist/components/wm-standard-view';

library.add(fab, far, fas);

export { StandardForm, StandardView };
export function createCrud(baseURL, tokenGetter){
  Api.setBaseUrl(baseURL);
  Api.setTokenGetter(tokenGetter);
}
